const escapeCsvValue = (value) => {
  const string_value = value == null ? '' : String(value);
  if (/[",\n\r]/.test(string_value)) {
    return `"${string_value.replace(/"/g, '""')}"`;
  }
  return string_value;
};

const sanitizeFilename = (name) => {
  const sanitized = String(name || 'logs')
    .replace(/[<>:"/\\|?*\x00-\x1f]/g, '_')
    .trim();
  return sanitized || 'logs';
};

/**
 * Export loaded log messages to a CSV file (oldest to newest).
 * Does not fetch additional logs.
 */
function exportLogsToCsv(messages, { filename, include_worker = false } = {}) {
  if (!messages || messages.length === 0) {
    return;
  }

  const sorted = [...messages].sort((a, b) => a.time - b.time);
  const headers = include_worker
    ? ['Time', 'Message', 'Worker']
    : ['Time', 'Message'];

  const rows = sorted.map(({ msg, time, worker_num }) => {
    const cells = [
      escapeCsvValue(new Date(time).toISOString()),
      escapeCsvValue(msg),
    ];
    if (include_worker) {
      cells.push(escapeCsvValue(worker_num != null ? worker_num : ''));
    }
    return cells.join(',');
  });

  const csv_content = [headers.join(','), ...rows].join('\n');
  const blob = new Blob([csv_content], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${sanitizeFilename(filename)}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export default exportLogsToCsv;
